/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const person_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M16.238 22.54a.75.75 0 1 0 1.498-.08l-1.498.08Zm-9.974-.08a.75.75 0 0 0 1.498.08l-1.498-.08ZM12 17.75c1.36 0 2.353.513 3.038 1.328.702.834 1.125 2.038 1.2 3.462l1.498-.08c-.088-1.656-.585-3.201-1.55-4.348-.981-1.165-2.4-1.862-4.186-1.862v1.5Zm-4.238 4.79c.075-1.424.498-2.628 1.2-3.462.685-.815 1.679-1.328 3.038-1.328v-1.5c-1.786 0-3.205.697-4.186 1.862-.965 1.147-1.463 2.692-1.55 4.349l1.498.079ZM17.25 7c0 2.9-2.35 5.25-5.25 5.25v1.5A6.75 6.75 0 0 0 18.75 7h-1.5ZM12 12.25A5.25 5.25 0 0 1 6.75 7h-1.5A6.75 6.75 0 0 0 12 13.75v-1.5ZM6.75 7c0-2.9 2.35-5.25 5.25-5.25V.25A6.75 6.75 0 0 0 5.25 7h1.5ZM12 1.75c2.9 0 5.25 2.35 5.25 5.25h1.5A6.75 6.75 0 0 0 12 .25v1.5Z"
    />
  </svg>
)
export default person_medium
